var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3378,
    cy: 24.293,
    r: 23.5212,
    transform: "rotate(-179.348 24.3378 24.293)",
    fill: "white",
    fillOpacity: 0.06,
    stroke: "url(#paint0_linear_355_44)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_44",
    x1: 24.3378,
    y1: 48.3141,
    x2: 24.3378,
    y2: 0.271811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907EFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSocialIcon);
export default __webpack_public_path__ + "static/media/footer-social-icon.58111e9716938c9e8299d6da95467349.svg";
export { ForwardRef as ReactComponent };